/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { CcbSwitch } from './CcbSwitch';
import { CcbSwitchName } from './enums';

// TODO: Remove this method on completion of ENABLE_VOD_JUMP_CHANNEL_REMOVE_IN_KST_12189
export const isJumpChannelCcbSwitchEnabled = () => {
    return CcbSwitch.getInstance().isEnabledAndOverriden(
        CcbSwitchName.ENABLE_VOD_JUMP_CHANNEL_REMOVE_IN_KST_12189,
    );
};
